import { render, staticRenderFns } from "./comics_details.vue?vue&type=template&id=0d94a2ca&scoped=true&"
import script from "./comics_details.vue?vue&type=script&lang=js&"
export * from "./comics_details.vue?vue&type=script&lang=js&"
import style0 from "./comics_details.vue?vue&type=style&index=0&id=0d94a2ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d94a2ca",
  null
  
)

export default component.exports